import { styled } from '@mui/material';
import { GridFilterPanel, gridClasses } from '@mui/x-data-grid-pro';
import { ComponentProps } from 'react';

/** Styled to fix vertical alignment of the filter panel inputs */
export const StyledGridFilterPanel: React.ComponentType<ComponentProps<typeof GridFilterPanel>> = styled(
  GridFilterPanel
)(() => ({
  [`& .${gridClasses.filterForm}`]: {
    display: 'flex',
    alignItems: 'baseline',

    [`& .${gridClasses.filterFormColumnInput}, & .${gridClasses.filterFormOperatorInput}, & .${gridClasses.filterFormValueInput}`]:
      {
        height: '100%',
        overflow: 'hidden',
        justifyContent: 'end',
        margin: '0 2px',
      },
  },
}));
